module.exports = __webpack_public_path__ + "static/yarra_2_square-a202db671ebf39febe967840a9c53ebd.jpg";